module.exports = __webpack_public_path__ + "images/emoji/frowning.d779eddc4231378a546e.png";